import React from "react";
import {
  Row,
  Col,
  Label,
  Input,
  FormGroup
} from 'reactstrap';

const Hospital = (props) => (
  <Row>
    <Col xs="12" md="4">
      <FormGroup>
        {props.name == "gyno" ? 
          <Label for="exampleEmail">
            Gynecologist Name<span className="asterisc">*</span>
          </Label> : 
          <Label>
            Doctor's Name<span className="asterisc">*</span>
          </Label>
        }
        <Input
          type="text"
          name="gyno"
          placeholder="Full Name"
          value={props.values.gyno}
          onChange={props.handleChange}
        />
        {props.errors.gyno && props.touched.gyno && <div id="feedback" className="text-danger">{props.errors.gyno}</div>}
      </FormGroup>
    </Col>
    <Col xs="12" md="4">
      <FormGroup>
        <Label for="hospitalName">
          Hospital Name<span className="asterisc">*</span>
        </Label>
        <Input
          type="text"
          name="hospital"
          placeholder="Name"
          value={props.values.hospital}
          onChange={props.handleChange}                
        />
        {props.errors.hospital && props.touched.hospital && <div id="feedback" className="text-danger">{props.errors.hospital}</div>}
      </FormGroup>
    </Col>
    <Col xs="12" md="4">
      <FormGroup>
        <Label for="phone">Phone No.</Label>
        <Input
          type="text"
          placeholder="Enter Hospital/Clinic Phone Number"
          name="phone"
          value={props.values.phone}
          onChange={props.handleChange}
        />
        {props.errors.phone && props.touched.phone && <div id="feedback" className="text-danger">{props.errors.phone}</div>}
      </FormGroup>
    </Col>
  </Row>
)

export default Hospital;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/Hospital.js